/* eslint-disable */
import React, { useCallback, useMemo } from 'react';
import { connect } from 'dva';
import { openInBrowser } from '@/utils/bridge';
import { TEMPLATE_B } from '../config/pars';
import styles from '../styles/index.less';

const toRuleDetail = (url = '') => {
  openInBrowser({
    url,
  });
};

const BizItem = ({
  bizData: {
    detail,
    detail_v2,
    template_type,
    biz_name,
    biz_id,
    business_title,
    reward_desc,
    request_desc_multi,
    detail_url,
    business_tag,
  },
  handleJoinBtnClick,
  reportBtnClick,
  isFinish,
}) => {
  const isTemplateB = useMemo(() => template_type === TEMPLATE_B, [template_type]);
  const capacityList = useMemo(() => (isTemplateB ? detail_v2 : detail), [
    isTemplateB,
    detail,
    detail_v2,
  ]);
  const renderBtnText = useCallback(() => (isFinish ? '已招满' : '立即加入'), [isFinish]);

  const business_tag_arr = useMemo(() => business_tag? business_tag.split(','): [])
  console.log(business_tag_arr)

  const jumpToDetail = useCallback(() => {
    reportBtnClick('requirement', { type: biz_id });
    if (detail_url) toRuleDetail(detail_url);
  }, [biz_id, detail_url]);

  return (
    <>
      <div className={`${styles['part']} ${isFinish ? styles['finish'] : ''}`} id={`biz${biz_id}`}>
        <label className={styles['part-tit']}>{business_title || biz_name}</label>
        <p style={{textAlign: 'center', fontSize: '14px', marginBottom: '10px'}}>
          {
            business_tag_arr.map(item => {
              if (item.indexOf('provincial') > -1) {
                return <span className={styles['reward_desc_tag']}>可同省调度</span>
              }
            })
          }
          {business_tag_arr.some(item => item.indexOf('peak') > -1) && (
            <span className={styles['reward_desc_tag']} style={{color: '#d46b08', background: '#fff7e6'}}>可限制时段</span>
          )
          }
        </p>
        <p className={styles['p1']}>{reward_desc}</p>
        <div className={styles['rules']}>
          <p className={styles['rules-tit']}>资源要求</p>
          <div
            className={styles['rule-list']}
            dangerouslySetInnerHTML={{ __html: request_desc_multi }}
          />
        </div>
        {isTemplateB
          ? capacityList?.length > 0 && (
              <table className={styles['table']}>
                <thead>
                  <tr>
                    <th style={{ width: '.95rem' }}>区域</th>
                    <th>省份</th>
                    <th style={{ width: '1rem' }}>运营商</th>
                    <th style={{ width: '.8rem' }}>需求容量</th>
                  </tr>
                </thead>
                <tbody>
                  {capacityList.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row.area}</td>
                      <td>{row.province.split(',').join('、')}</td>
                      <td>{row.isp}</td>
                      <td>{row.capacity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          : capacityList?.length > 0 && (
              <table className={styles['table']}>
                <thead>
                  <tr>
                    <th style={{ width: '.95rem' }}>区域</th>
                    <th>省份</th>
                    <th style={{ width: '.8rem' }}>电信</th>
                    <th style={{ width: '.8rem' }}>联通</th>
                    <th style={{ width: '.8rem' }}>移动</th>
                  </tr>
                </thead>
                <tbody>
                  {capacityList.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row.area}</td>
                      <td>{row.province.split(',').join('、')}</td>
                      <td>{row.tel}</td>
                      <td>{row.unicom}</td>
                      <td>{row.mobile}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        <div className={styles['btns']}>
          <button
            className={`${styles['btn-guide']} ${isFinish ? styles['disabled'] : ''}`}
            onClick={jumpToDetail}
            disabled={isFinish}
          >
            上机指南
          </button>
          <button
            className={`${styles['btn-join']} ${isFinish ? styles['disabled'] : ''}`}
            onClick={() => handleJoinBtnClick(biz_id)}
            disabled={isFinish}
          >
            {renderBtnText()}
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, null)(BizItem);
